"use client";

import { useUser } from "@/lib/auth/client";
import { useEffect } from "react";
import { initMixpanel } from "./mixpanel";
import { launchSessionReview } from "./sessionrewind";
import { initPylon, setupPylonEditorHideEvent } from "./pylon";
import * as Sentry from "@sentry/nextjs";
import { useSpotUser } from "./spotUser";

export const CustomerToolsInjectorAux = ({
  isEnvReady,
}: {
  isEnvReady: boolean;
}) => {
  const { user } = useUser();
  const { spotUser } = useSpotUser();
  /* Pylon, Session Rewind and Mixpanel */
  useEffect(() => {
    if (isEnvReady) {
      launchSessionReview(user?.email || "", user?.name || "");
      initMixpanel(user?.email || "", user?.name || "");
      initPylon(
        user?.name || user?.email || undefined,
        user?.email || "",
        user?.picture || undefined,
        spotUser?.tenant_id || undefined
      );
    }
  }, [user, spotUser, isEnvReady]);

  /* Pylon function setup */
  useEffect(() => {
    setupPylonEditorHideEvent();
  }, []);

  useEffect(() => {
    Sentry.setUser({ email: user?.email || "" });
  }, [user]);

  return <></>;
};
